import {
  LOAD_CURRENT_SONG,
  UNLOAD_CURRENT_ARTIST,
  UNLOAD_CURRENT_SONG,
} from '../actionTypes';
import { loadReducer } from './helpers';

export const currentSong = (state = null, action) => {
  switch (action.type) {
    case UNLOAD_CURRENT_ARTIST:
    case UNLOAD_CURRENT_SONG:
      return null;

    case LOAD_CURRENT_SONG: {
      const nextState = loadReducer(state, action);

      return {
        ...nextState,
        data: {
          id: action.meta.songId,
          ...nextState.data,
        },
      };
    }

    default:
      return state;
  }
};
